import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";
import PrintPurchaseOrder from "./PrintPurchaseOrder";
import { useDispatch, useSelector } from "react-redux";
import {
  getPartCandidatePoOrders,
  loadPartCandidatePoOrders,
} from "../../app/store/partner";
import {
  getCurrentClientDeatils,
  getCurrentUser,
  getLoggedUserDetails,
  loadClientDetails,
  loadUserDetails,
} from "../../app/store/auth";
import {
  getPoOrderDocumentData,
  loadPoOrderdownloadDocument,
  poOrderDownloadDataRecevied,
} from "../../app/store/documents";

const PURCHASE_ORDER_STYLES = {
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "linear-gradient(135deg, #ffffff 0%, #eff6ff 100%)"
  },
  headerRow: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  titleIcon: {
    width: "42px",
    height: "42px",
    borderRadius: "14px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
    border: "1px solid rgba(191, 219, 254, 1)",
    color: "#1d4ed8",
    fontSize: "17px",
    flexShrink: 0
  },
  eyebrow: {
    margin: "0 0 3px",
    color: "#4f46e5",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.12em",
    textTransform: "uppercase"
  },
  title: {
    margin: 0,
    color: "#0f172a",
    fontSize: "20px",
    fontWeight: 800,
    lineHeight: 1.15
  },
  subtitle: {
    margin: "4px 0 0",
    color: "#64748b",
    fontSize: "12px",
    lineHeight: 1.5
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 800,
    boxShadow: "0 8px 18px rgba(15, 23, 42, 0.06)",
    flexShrink: 0
  },
  modalBody: {
    padding: "20px 22px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
  },
  summaryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginBottom: "16px"
  },
  summaryCard: {
    borderRadius: "16px",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    background: "#ffffff",
    padding: "13px 14px",
    boxShadow: "0 10px 24px rgba(37, 99, 235, 0.06)"
  },
  summaryLabel: {
    margin: "0 0 6px",
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase"
  },
  summaryValue: {
    margin: 0,
    color: "#0f172a",
    fontSize: "22px",
    fontWeight: 800,
    lineHeight: 1.1
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "12px"
  },
  toolbarText: {
    margin: 0,
    color: "#64748b",
    fontSize: "12px",
    lineHeight: 1.5
  },
  refreshButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "8px 14px",
    fontSize: "12px",
    fontWeight: 700,
    whiteSpace: "nowrap"
  },
  subtleButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#334155",
    padding: "8px 14px",
    fontSize: "12px",
    fontWeight: 700,
    whiteSpace: "nowrap"
  },
  tableShell: {
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "16px",
    overflow: "hidden",
    backgroundColor: "#ffffff",
    boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)"
  },
  table: {
    marginBottom: 0,
    minWidth: "760px",
    tableLayout: "fixed"
  },
  tableHeadCell: {
    borderTop: "none",
    background: "#f8fafc",
    color: "#64748b",
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    padding: "13px 14px",
    textTransform: "uppercase",
    verticalAlign: "top"
  },
  tableCell: {
    borderTop: "1px solid rgba(241, 245, 249, 1)",
    background: "#ffffff",
    color: "#334155",
    fontSize: "13px",
    padding: "16px 14px",
    verticalAlign: "middle"
  },
  idPill: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "34px",
    height: "30px",
    borderRadius: "999px",
    backgroundColor: "#f1f5f9",
    color: "#475569",
    fontSize: "12px",
    fontWeight: 800
  },
  actionButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "7px",
    borderRadius: "999px",
    border: "1px solid rgba(224, 231, 255, 1)",
    background: "#eef2ff",
    color: "#4338ca",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
    textDecoration: "none",
    whiteSpace: "nowrap",
    lineHeight: 1.2
  },
  statusPillBase: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
    borderRadius: "999px",
    padding: "6px 10px",
    fontSize: "12px",
    fontWeight: 700,
    border: "1px solid transparent",
    marginBottom: "7px"
  },
  successPill: {
    color: "#166534",
    backgroundColor: "#f0fdf4",
    borderColor: "rgba(187, 247, 208, 1)"
  },
  warningPill: {
    color: "#92400e",
    backgroundColor: "#fffbeb",
    borderColor: "rgba(253, 230, 138, 1)"
  },
  mutedText: {
    display: "block",
    color: "#64748b",
    fontSize: "12px",
    lineHeight: 1.5
  },
  emptyState: {
    padding: "34px 20px",
    textAlign: "center",
    color: "#64748b",
    backgroundColor: "#ffffff"
  },
  emptyIcon: {
    width: "54px",
    height: "54px",
    margin: "0 auto 12px",
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #dbeafe 0%, #eff6ff 100%)",
    color: "#2563eb",
    fontSize: "22px"
  },
  emptyTitle: {
    margin: "0 0 6px",
    color: "#0f172a",
    fontSize: "16px",
    fontWeight: 800
  },
  emptyText: {
    margin: 0,
    color: "#64748b",
    fontSize: "13px",
    lineHeight: 1.5
  },
  modalFooter: {
    padding: "14px 22px 18px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  }
};

const PurchaseOrders = (props) => {
  const {
    handlePoShowHide,
    poShowHide,
    candidateObj,
    handleRefreshPartnerCandidates,
  } = props;

  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [poAction, setPoAction] = useState("");
  const [genShowHide, setGenShowHide] = useState(false);
  const [selectedPoOrder, setSelectedPoOrder] = useState(null);
  const [usrType, setUsrType] = useState("");
  const [clientDetails, setClientDetails] = useState(null);

  const loggedUserDetailsSelector = useSelector(getLoggedUserDetails);
  const partCandidatePoOrdersSelector = useSelector(getPartCandidatePoOrders);
  const poOrderDocumentDataSelector = useSelector(getPoOrderDocumentData);
  const currentClientDeatilsSelector = useSelector(getCurrentClientDeatils);

  let userType = localStorage.getItem("userType");
  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    if (userType === "PP") {
      if (!loggedUserDetailsSelector) dispatch(loadUserDetails(currentUser.id));
    } else {
      setUsrType(userType);
    }
  }, []);

  useEffect(() => {
    if (!currentClientDeatilsSelector) dispatch(loadClientDetails());
  }, []);

  useEffect(() => {
    if (currentClientDeatilsSelector)
      setClientDetails(currentClientDeatilsSelector);
  }, [currentClientDeatilsSelector]);

  useEffect(() => {
    if (candidateObj?.performerid > 0 && usrType !== "")
      dispatch(loadPartCandidatePoOrders(candidateObj.performerid, usrType));
  }, [candidateObj, usrType]);

  useEffect(() => {
    if (loggedUserDetailsSelector && candidateObj?.id) {
      let uType = loggedUserDetailsSelector.partnerType;
      if (loggedUserDetailsSelector.partnerType === "Sub-Contractors")
        uType = "subcontractor";

      setUsrType(uType);
    }
  }, [loggedUserDetailsSelector]);

  useEffect(() => {
    setPurchaseOrders(partCandidatePoOrdersSelector);
  }, [partCandidatePoOrdersSelector]);

  const handleGenShowHide = (obj, action) => {
    if (obj === "save") {
      setGenShowHide(false);
      setPoAction("");
      setSelectedPoOrder("");
      if (candidateObj?.performerid > 0 && usrType !== "") {
        dispatch(loadPartCandidatePoOrders(candidateObj.performerid, usrType));
        if (handleRefreshPartnerCandidates) {
          handleRefreshPartnerCandidates();
        }
      }
    } else {
      setGenShowHide(!genShowHide);
      setPoAction(action);
      setSelectedPoOrder(obj);
    }
  };

  const handleDownloadFile = (item, type) => {
    dispatch(loadPoOrderdownloadDocument(item.id, type));
  };

  useEffect(() => {
    if (poOrderDocumentDataSelector?.uploadUrl) {
      // const url = window.URL.createObjectURL(poOrderDocumentDataSelector);
      // const link = document.createElement("a");
      // link.href = url;
      // link.target = "_blank";
      // document.body.appendChild(link);
      // link.click();
      // link.parentNode.removeChild(link);
      window.open(poOrderDocumentDataSelector?.uploadUrl, "_blank");
      dispatch(poOrderDownloadDataRecevied(null));
    }
  }, [poOrderDocumentDataSelector]);

  const handlePoRefresh = () => {
    if (candidateObj?.performerid > 0 && usrType !== "")
      dispatch(loadPartCandidatePoOrders(candidateObj.performerid, usrType));
  };

  const signedCount = purchaseOrders.filter((item) => item.partnerSignedData).length;
  const pendingCount = purchaseOrders.filter((item) => item.partnerSign === null).length;
  const candidateName = [candidateObj?.performername, candidateObj?.lastName]
    .filter(Boolean)
    .join(" ");

  return (
    <React.Fragment>
      <Modal show={poShowHide} size="xl" centered onHide={() => handlePoShowHide("")}>
        <Modal.Header style={PURCHASE_ORDER_STYLES.modalHeader}>
          <div style={PURCHASE_ORDER_STYLES.headerRow}>
            <Modal.Title as="div" style={PURCHASE_ORDER_STYLES.titleWrap}>
              <span style={PURCHASE_ORDER_STYLES.titleIcon}>
                <i className="fa fa-file-text-o" aria-hidden="true"></i>
              </span>
              <div>
                <p style={PURCHASE_ORDER_STYLES.eyebrow}>Purchase Orders</p>
                <h2 style={PURCHASE_ORDER_STYLES.title}>
                  {candidateName || "Candidate Purchase Orders"}
                </h2>
                <p style={PURCHASE_ORDER_STYLES.subtitle}>
                  Review, download, and complete pending eSign purchase orders.
                </p>
              </div>
            </Modal.Title>
            <button
              type="button"
              style={PURCHASE_ORDER_STYLES.closeButton}
              onClick={() => handlePoShowHide("")}
              aria-label="Close purchase orders popup"
            >
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </Modal.Header>
        <Modal.Body style={PURCHASE_ORDER_STYLES.modalBody}>
          <div style={PURCHASE_ORDER_STYLES.summaryGrid}>
            <div style={PURCHASE_ORDER_STYLES.summaryCard}>
              <p style={PURCHASE_ORDER_STYLES.summaryLabel}>Total Orders</p>
              <p style={PURCHASE_ORDER_STYLES.summaryValue}>{purchaseOrders.length}</p>
            </div>
            <div style={PURCHASE_ORDER_STYLES.summaryCard}>
              <p style={PURCHASE_ORDER_STYLES.summaryLabel}>Pending eSign</p>
              <p style={PURCHASE_ORDER_STYLES.summaryValue}>{pendingCount}</p>
            </div>
            <div style={PURCHASE_ORDER_STYLES.summaryCard}>
              <p style={PURCHASE_ORDER_STYLES.summaryLabel}>Signed</p>
              <p style={PURCHASE_ORDER_STYLES.summaryValue}>{signedCount}</p>
            </div>
          </div>
          <div style={PURCHASE_ORDER_STYLES.toolbar}>
            <p style={PURCHASE_ORDER_STYLES.toolbarText}>
              Purchase order documents open in a new tab. Signed copies are available after eSign is complete.
            </p>
            <button
              className="btn btn-sm"
              style={PURCHASE_ORDER_STYLES.refreshButton}
              onClick={handlePoRefresh}
            >
              <i className="fa fa-refresh" aria-hidden="true"></i> Refresh
            </button>
          </div>
          <div className="table-responsive" style={PURCHASE_ORDER_STYLES.tableShell}>
            <table className="table align-items-center table-hover mb-0" style={PURCHASE_ORDER_STYLES.table}>
              <thead>
                <tr>
                  <th style={PURCHASE_ORDER_STYLES.tableHeadCell}></th>
                  <th style={PURCHASE_ORDER_STYLES.tableHeadCell}>Date & Time</th>
                  <th style={PURCHASE_ORDER_STYLES.tableHeadCell}>IPCS Purchase Order</th>
                  <th style={PURCHASE_ORDER_STYLES.tableHeadCell}>Partner Status</th>
                  <th style={PURCHASE_ORDER_STYLES.tableHeadCell}>Signed Copy</th>
                </tr>
              </thead>
              <tbody>
                {purchaseOrders.map((item, key) => (
                  <tr key={item.id || key}>
                    <td style={PURCHASE_ORDER_STYLES.tableCell}>
                      <span style={PURCHASE_ORDER_STYLES.idPill}>{key + 1}</span>
                    </td>
                    <td style={PURCHASE_ORDER_STYLES.tableCell}>
                      <span style={PURCHASE_ORDER_STYLES.mutedText}>
                        <Moment format="MMM Do YYYY, h:mm a">
                          {item.addedDateTime}
                        </Moment>
                      </span>
                    </td>
                    <td style={PURCHASE_ORDER_STYLES.tableCell}>
                      <button
                        className="btn btn-sm"
                        style={PURCHASE_ORDER_STYLES.actionButton}
                        onClick={() => handleDownloadFile(item, "ipcs")}
                      >
                        <i className="fa fa-file-text-o" aria-hidden="true"></i>
                        Download/View
                      </button>
                    </td>
                    <td style={PURCHASE_ORDER_STYLES.tableCell}>
                      {item.partnerSign === null && (
                        <React.Fragment>
                          <span style={{ ...PURCHASE_ORDER_STYLES.statusPillBase, ...PURCHASE_ORDER_STYLES.warningPill }}>
                            <i className="fa fa-clock-o" aria-hidden="true"></i> Pending eSign
                          </span>
                          <br />
                          <a
                            className="btn btn-sm"
                            style={PURCHASE_ORDER_STYLES.actionButton}
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`${process.env.REACT_APP_ESIGN_BASEURL}/${item?.id}_${item.ciid}_${currentUser?.id}_${clientDetails?.clientId}_${item.ipcsPoName}_partner`}
                          >
                            <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                            WF eSign
                          </a>
                        </React.Fragment>
                      )}
                      {item.partnerSignedData && (
                        <React.Fragment>
                          <span style={{ ...PURCHASE_ORDER_STYLES.statusPillBase, ...PURCHASE_ORDER_STYLES.successPill }}>
                            <i className="fa fa-check" aria-hidden="true"></i> Signed
                          </span>
                          <span style={PURCHASE_ORDER_STYLES.mutedText}>
                            <Moment format="MMM Do YYYY, h:mm a">
                              {item.partnerSignDateTime}
                            </Moment>
                          </span>
                        </React.Fragment>
                      )}
                    </td>
                    <td style={PURCHASE_ORDER_STYLES.tableCell}>
                      {item.partnerSignedData ? (
                        <button
                          className="btn btn-sm"
                          style={PURCHASE_ORDER_STYLES.actionButton}
                          onClick={() => handleDownloadFile(item, "partner")}
                        >
                          <i className="fa fa-download" aria-hidden="true"></i>
                          Download/View
                        </button>
                      ) : (
                        <span style={PURCHASE_ORDER_STYLES.mutedText}>Available after signature</span>
                      )}
                    </td>
                  </tr>
                ))}
                {purchaseOrders.length === 0 && (
                  <tr>
                    <td colSpan={5} className="p-0 border-0">
                      <div style={PURCHASE_ORDER_STYLES.emptyState}>
                        <div style={PURCHASE_ORDER_STYLES.emptyIcon}>
                          <i className="fa fa-file-text-o" aria-hidden="true"></i>
                        </div>
                        <h4 style={PURCHASE_ORDER_STYLES.emptyTitle}>No purchase orders found</h4>
                        <p style={PURCHASE_ORDER_STYLES.emptyText}>
                          Purchase orders will appear here once they are generated and sent for this candidate.
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer style={PURCHASE_ORDER_STYLES.modalFooter}>
          <button
            className="btn btn-sm"
            style={PURCHASE_ORDER_STYLES.subtleButton}
            onClick={() => handlePoShowHide("")}
          >
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </button>
        </Modal.Footer>
      </Modal>
      {genShowHide && candidateObj?.performerid > 0 && (
        <PrintPurchaseOrder
          genShowHide={genShowHide}
          handleGenShowHide={handleGenShowHide}
          candidateObj={candidateObj}
          poOrder={selectedPoOrder}
          poAction={poAction}
        ></PrintPurchaseOrder>
      )}
    </React.Fragment>
  );
};

export default PurchaseOrders;
